import { render } from "./PressReleases.vue?vue&type=template&id=39fbd021"
import script from "./PressReleases.vue?vue&type=script&lang=js"
export * from "./PressReleases.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev_storage\\webs\\tc_web\\web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__